// extracted by mini-css-extract-plugin
export var borderRadius = "_9l-4";
export var large = "_9l-3";
export var logoContainer = "_9l-0";
export var nameLogo = "_9l-2";
export var small = "_9l-1";